var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-context',{ref:"menu"},[_c('ul',[(_vm.idParam != null)?_c('li',[_c('router-link',{attrs:{"to":{ name: _vm.linkName, params: { id: _vm.idParam } },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('message.open_in_new_tab'))+" ")])],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }